
import {FC, useMemo} from 'external/react'

import { calculateDiscounts, Offer } from '../../../types/offer'

export type OfferDiscountHeaderProps = {
    offer: Offer
}

const OfferDiscountHeader: FC<OfferDiscountHeaderProps> = (props) => {
	
	const { offer } = props
	const {name, plan, price} = offer

	const [discountedPrice, discountedAmount] = useMemo (() => calculateDiscounts(offer), [offer])

	return (
		<>
			<p style={{ margin: '0' }}>
				${discountedPrice}{' '}
				<span className='span_plan text-capitalize'>/{plan}</span>
			</p>
			<div className='programLevel text-capitalize'>{name}</div>
			<p className='span_plan m-auto text-red' style={{ fontWeight: '500' }}>
				{discountedAmount} de descuento{' '}
				<b style={{ textDecoration: 'line-through' }}>{price}</b>
			</p>
		</>
	)
}

export {OfferDiscountHeader as default}